/*
Update the "has items in bag" indicator in shopping bag nav icon when adding or removing items within the Smart Cart
*/

function updateCartCountBadges() {
  // Get cart count from Shopify cart API to ensure accuracy
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count || 0;

      let shoppingBagIcon = document.querySelector('#shopping_bag_icon > a');
      let shoppingBagHasIems = shoppingBagIcon && shoppingBagIcon.classList ? shoppingBagIcon.classList.contains('cart-toggle-has-items') : false;

      let mobileShoppingBagIcon = document.querySelector('.mobile-menu > a.cart__toggle');
      let mobileShoppingBagHasIems = mobileShoppingBagIcon && mobileShoppingBagIcon.classList ? mobileShoppingBagIcon.classList.contains('cart-toggle-has-items') : false;

      let rebuyCartFlyoutContent = document.getElementsByClassName("rebuy-cart__flyout-content")[0];
      let isHasItemsPresent = rebuyCartFlyoutContent && rebuyCartFlyoutContent.classList ? rebuyCartFlyoutContent.classList.contains("has-items") : false;
      let isNoItemsPresent = rebuyCartFlyoutContent && rebuyCartFlyoutContent.classList ? rebuyCartFlyoutContent.classList.contains("no-items") : false;

      // Update cart count badges with actual Shopify cart count
      const cartCountBadges = document.querySelectorAll('[data-cart-count]');
      cartCountBadges.forEach((badge) => {
        if (cartCount > 0) {
          badge.textContent = cartCount;
          badge.style.display = 'flex';
        } else {
          badge.textContent = '0';
          badge.style.display = 'none';
        }
      });

      if (isHasItemsPresent || cartCount > 0) {
        if (shoppingBagIcon && shoppingBagIcon.classList && !shoppingBagHasIems) {
          shoppingBagIcon.classList.add("cart-toggle-has-items");
        }
        if (mobileShoppingBagIcon && mobileShoppingBagIcon.classList && !mobileShoppingBagHasIems) {
          mobileShoppingBagIcon.classList.add("cart-toggle-has-items");
        }
      }

      if (isNoItemsPresent || cartCount === 0) {
        if (shoppingBagIcon && shoppingBagIcon.classList && shoppingBagHasIems) {
          shoppingBagIcon.classList.remove("cart-toggle-has-items");
        }
        if (mobileShoppingBagIcon && mobileShoppingBagIcon.classList && mobileShoppingBagHasIems) {
          mobileShoppingBagIcon.classList.remove("cart-toggle-has-items");
        }
      }
    })
    .catch(error => {
      console.error('Error fetching cart count:', error);
    });
}

document.addEventListener('rebuy:cart.change', function(event){ 
  // Update immediately
  setTimeout(() => {
    updateCartCountBadges();
  }, 500);
  
  // Update again after 3.5 seconds to override any main theme updates that might have cleared it
  setTimeout(() => {
    updateCartCountBadges();
  }, 3500);
}); 

